import { compose } from 'redux';

import {
    WithFetchDatasByParamsFromCMS,
    WithFetchDatasByParamsFromCMSInputProps,
} from 'modules/shared-cms-advanced/hocs';
import { GetGame } from '../../models';

import { GameParticipationConfirmationProps } from './game-participation-confirmation-type';
import { GameParticipationConfirmationLoader } from './game-participation-confirmation-loader';
import { QUERY } from './game-participation-confirmation-query';

const enhancer = compose<React.ComponentType<WithFetchDatasByParamsFromCMSInputProps & GetGame>>(
    WithFetchDatasByParamsFromCMS<GameParticipationConfirmationProps>(
        GameParticipationConfirmationLoader,
        QUERY,
        'queryJeuContents',
        [{ filter: 'data/gameId/iv eq $id' }],
        'game',
    ),
);

export default enhancer;
